import { ArcadeWheel } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
import { FeatureStateType } from "../../../model/GameModel";
export class GameArcardWheel extends ArcadeWheel {
    handleHelpDialogClose() {
        if (!(this.model.getFeatureState() === FeatureStateType.IN_PROGRESS)) {
            super.handleHelpDialogClose();
        }
        ;
    }
}
//# sourceMappingURL=GameArcadeWheel.js.map